/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S2_Th_ChannelInputs */

const tr_kvkkbasvuru_s2_th_channel = /** @type {(inputs: Kvkkbasvuru_S2_Th_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanal`)
};

const en_kvkkbasvuru_s2_th_channel = /** @type {(inputs: Kvkkbasvuru_S2_Th_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Channel`)
};

const de_kvkkbasvuru_s2_th_channel = /** @type {(inputs: Kvkkbasvuru_S2_Th_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanal`)
};

const ru_kvkkbasvuru_s2_th_channel = /** @type {(inputs: Kvkkbasvuru_S2_Th_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Канал`)
};

/**
* | output |
* | --- |
* | "Channel" |
*
* @param {Kvkkbasvuru_S2_Th_ChannelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s2_th_channel = /** @type {((inputs?: Kvkkbasvuru_S2_Th_ChannelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S2_Th_ChannelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s2_th_channel(inputs)
	if (locale === "de") return de_kvkkbasvuru_s2_th_channel(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s2_th_channel(inputs)
	return tr_kvkkbasvuru_s2_th_channel(inputs)
});